export let realTimeValidation = false;

export const validateForm = (formik) => {
  formik.validateForm();
  if (Object.keys(formik.errors).length > 0) {
    let fields = Object.keys(formik.errors);
    fields.forEach((fields) => {
      formik.touched[fields] = true;
    });
    realTimeValidation = true;
    return false;
  }
  return true;
};

export const validateFormAsync = async (formik) => {
  const errors = await formik.validateForm();
  const fields = Object.keys(errors);

  if (fields.length > 0) {
    const touchedFields = fields.reduce((acc, field) => {
      acc[field] = true;
      return acc;
    }, {});

    formik.setTouched({ ...formik.touched, ...touchedFields }, false);
    realTimeValidation = true;
    return false;
  }

  return true;
};

export const resetValidation = () => {
  realTimeValidation = false;
};
